import { render, staticRenderFns } from "./ButtonSolid.vue?vue&type=template&id=2883e968&scoped=true"
import script from "./ButtonSolid.vue?vue&type=script&lang=ts"
export * from "./ButtonSolid.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSolid.vue?vue&type=style&index=0&id=2883e968&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2883e968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2883e968')) {
      api.createRecord('2883e968', component.options)
    } else {
      api.reload('2883e968', component.options)
    }
    module.hot.accept("./ButtonSolid.vue?vue&type=template&id=2883e968&scoped=true", function () {
      api.rerender('2883e968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ButtonSolid.vue"
export default component.exports